<template>
  <div>
    <v-expansion-panels v-model="openPanelIndexList" hover multiple>
      <v-expansion-panel
        v-for="(oldItem, oldItemIndex) in constantOldLocaleList"
        :key="`old-${oldItemIndex}`"
        :disabled="$_isPanelDisabled(oldItemIndex)"
      >
        <v-expansion-panel-header expand-icon="mdi-menu-down">
          <template>
            <div class="d-flex justify-space-between">
              <div>
                {{ oldItem.no_text }}
              </div>
              <div :class="(_headerStatusList[oldItemIndex] || { class: [] }).class">
                {{ (_headerStatusList[oldItemIndex] || { text: '' }).text }}
              </div>
            </div>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col>
              <WsContentTitle v-if="leftTitle" class="mb-2">{{ leftTitle }}</WsContentTitle>
              <WsCard shadowBold>
                <WsContent>
                  <WsState
                    v-for="(field, fieldKey) in displayFields"
                    :key="fieldKey"
                    :value="oldItem[fieldKey]"
                    disabled
                    :type="field.type"
                    :label="field.label"
                  />
                </WsContent>
              </WsCard>
            </v-col>
            <v-col>
              <WsContentTitle v-if="rightTitle" class="mb-2">{{ rightTitle }}</WsContentTitle>
              <WsCard v-if="_rightItemsList[oldItemIndex]" shadowBold>
                <WsContent>
                  <WsState
                    v-for="(field, fieldKey) in displayFields"
                    :key="fieldKey"
                    :value="_rightItemsList[oldItemIndex][fieldKey]"
                    :disabled="_rightSideDisabledList[oldItemIndex]"
                    :isWarning="
                      _rightSideDisabledList[oldItemIndex]
                        ? false
                        : $_isWarning(oldItem, oldItemIndex, fieldKey)
                    "
                    :type="field.type"
                    :label="field.label"
                    @input="$_onInput($event, oldItemIndex, fieldKey)"
                  />
                </WsContent>
              </WsCard>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  props: {
    leftTitle: {
      type: String,
      default: '',
    },
    rightTitle: {
      type: String,
      default: '',
    },
    oldList: {
      type: Array,
      required: true,
    },
    newList: {
      type: Array,
      required: true,
    },
    oldLocale: {
      type: String,
      required: true,
    },
    newLocale: {
      type: String,
      required: true,
    },
    displayFields: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      constantOldLocaleList: [],
      constantNewLocaleList: [],
      openPanelIndexList: [],
    };
  },
  computed: {
    _hasConstantNewLocaleList() {
      return this.constantNewLocaleList && this.constantNewLocaleList.length > 0;
    },
    _headerStatusList() {
      return this.constantOldLocaleList.map((oldItem, oldItemIndex) => {
        if (this._hasConstantNewLocaleList && this.constantNewLocaleList[oldItemIndex]) {
          return { text: '已有翻譯', class: ['blue--text', 'text--darken-3'] };
        }
        const newItem = this.$_getNewItemValue(oldItemIndex);
        if (!newItem) {
          return { text: '無匯入翻譯', class: ['grey--text', 'text--lighten-1'] };
        }
        if (this.$_fieldIsNotMatch(oldItem, oldItemIndex)) {
          return {
            text: '填入欄位數量有差異，或是條文文字數字不一致',
            class: ['red--text'],
          };
        }
        return { text: '', class: [] };
      });
    },
    _rightItemsList() {
      return this.constantOldLocaleList.map((_item, oldItemIndex) =>
        this.$_getRightItem(oldItemIndex),
      );
    },
    _rightSideDisabledList() {
      return this.constantOldLocaleList.map((_item, oldItemIndex) =>
        this.$_isRightSideDisabled(oldItemIndex),
      );
    },
  },
  watch: {
    oldList() {
      this.$_init();
    },
    newList() {
      this.$_init();
    },
  },
  mounted() {
    this.$_init();
  },
  methods: {
    $_init() {
      this.$_initConstantList(this.oldList, this.oldLocale, this.newLocale);
      this.$_initOpenPanelIndexList();
    },
    $_initOpenPanelIndexList() {
      this.openPanelIndexList = this.constantOldLocaleList.map((_item, index) => index);
      if (this.constantNewLocaleList.length > 0) {
        this.openPanelIndexList.splice(0, this.constantNewLocaleList.length);
      }
      if (this.newList.length > 0 && this.newList.length < this.openPanelIndexList.length) {
        this.openPanelIndexList.splice(
          this.newList.length,
          this.openPanelIndexList.length - this.newList.length,
        );
      }
    },
    $_initConstantList(rawList, oldLocale, newLocale) {
      this.constantOldLocaleList = [];
      this.constantNewLocaleList = [];
      rawList.forEach((item) => {
        const locales = item.locales;
        if (!locales) return;
        const oldData = locales[oldLocale];
        const newData = locales[newLocale];
        if (oldData) this.constantOldLocaleList.push(oldData);
        if (newData) this.constantNewLocaleList.push(newData);
      });
    },
    $_getNewItemValue(oldItemIndex) {
      if (!this.newList || this.newList.length === 0) return null;
      return (
        this.newList[
          this._hasConstantNewLocaleList
            ? oldItemIndex - this.constantNewLocaleList.length
            : oldItemIndex
        ] || null
      );
    },
    $_getRightItem(oldItemIndex) {
      if (this._hasConstantNewLocaleList && this.constantNewLocaleList[oldItemIndex]) {
        return this.constantNewLocaleList[oldItemIndex];
      }
      return this.$_getNewItemValue(oldItemIndex);
    },
    $_isRightSideDisabled(oldItemIndex) {
      return !!(this._hasConstantNewLocaleList && this.constantNewLocaleList[oldItemIndex]);
    },
    $_isPanelDisabled(oldItemIndex) {
      const hasConstant =
        this._hasConstantNewLocaleList && this.constantNewLocaleList[oldItemIndex];
      const hasNew = this.$_getNewItemValue(oldItemIndex);
      return !hasConstant && !hasNew;
    },
    $_fieldValuesMatch(oldVal, newVal, fieldKey) {
      if (fieldKey === 'no_text') {
        if (!!newVal !== !!oldVal) return false;
        if (newVal && oldVal) {
          const newNum = String(newVal).replace(/\D/g, '');
          const oldNum = String(oldVal).replace(/\D/g, '');
          return newNum === oldNum;
        }
        return true;
      }
      return !!newVal === !!oldVal;
    },
    $_isWarning(oldItem, oldItemIndex, fieldKey) {
      const newItem = this.$_getNewItemValue(oldItemIndex);
      if (!newItem) return false;
      const newFieldVal = newItem[fieldKey];
      const oldFieldVal = oldItem[fieldKey];
      return !this.$_fieldValuesMatch(oldFieldVal, newFieldVal, fieldKey);
    },
    $_fieldIsNotMatch(oldItem, oldItemIndex) {
      const newItem = this.$_getNewItemValue(oldItemIndex);
      if (!newItem) return false;
      for (const fieldKey in this.displayFields) {
        const newFieldVal = newItem[fieldKey];
        const oldFieldVal = oldItem[fieldKey];
        if (!this.$_fieldValuesMatch(oldFieldVal, newFieldVal, fieldKey)) {
          return true;
        }
      }
      return false;
    },
    $_onInput(event, oldItemIndex, fieldKey) {
      const newItemIndex = this._hasConstantNewLocaleList
        ? oldItemIndex - this.constantNewLocaleList.length
        : oldItemIndex;
      this.$emit('input', { newItemIndex, fieldKey, value: event });
    },
  },
};
</script>
